// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import StoreCreateAccountState from "@store/Framework/Store/Store/Pages/CreateAccount/StoreCreateAccountState";
import { Draft } from "immer";

const initialState: StoreCreateAccountState = {
    customerNumber: "",
    postalCode: "",
};

const actions = {
    "Store/Pages/CreateAccount/SetCreateAccountValues": (
        draft: Draft<StoreCreateAccountState>,
        action: { customerNumber?: string; postalCode?: string },
    ) => {
        if (action.customerNumber) {
            draft.customerNumber = action.customerNumber;
        }
        if (action.postalCode) {
            draft.postalCode = action.postalCode;
        }
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreCreateAccountActions = Parameters<typeof reducer>[1];
export default reducer;
